// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1wDoJ","header":"PatientBlock_header__wewbO","label":"PatientBlock_label__OjLkz","option":"PatientBlock_option__-0ZoU"};